import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { useTranslation } from "react-i18next";
import { usePromiseTracker } from "react-promise-tracker";

import { RootState } from "&store/store";
import { AppRouter } from "./App.router";
import { AuthRouter } from "./Auth.router";
import ConfigProvider from "./configProvider";
import Loader from "&styled/loader";

import { loginActions } from "./features/login/login.slice";
import { VerifyTwoFactorComponent } from "&features/twoFactor/verifyTwoFactor.component";

type ReduxProps = ConnectedProps<typeof connector>;

const App = (props: ReduxProps) => {
  const { isLoggedIn, isTwoFactor, token, reset } = props;
  const { i18n } = useTranslation();
  const { promiseInProgress } = usePromiseTracker();

  useEffect(() => {}, [i18n.language]);

  useEffect(() => {
    if (isLoggedIn && token) {
      try {
        const { exp } = JSON.parse(atob(token.split(".")[1]));
        if (exp && Date.now() / 1000 > exp) reset();
      } catch {
        reset();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderContent = () => {
    if (!isLoggedIn) return <AuthRouter />;
    if (isTwoFactor === false) return <VerifyTwoFactorComponent />;
    return <AppRouter />;
  };

  return (
    <>
      <ConfigProvider i18n={i18n}>
        {renderContent()}
      </ConfigProvider>

      {promiseInProgress && <Loader />}
    </>
  );
};

/**
 * Maps state variables from redux store to props of currect component
 * @param state
 */
const mapStateToProps = (state: RootState) => ({
  isLoggedIn: state.login.isLoggedIn,
  isTwoFactor: state.login.isTwoFactor,
  token: state.login.token,
});

/**
 * Maps actions from slices to props
 */
const mapDispatchToProps = {
  reset: loginActions.reset,
};

/**
 * Connects component to redux store
 */
const connector = connect(mapStateToProps, mapDispatchToProps);
const AppRedux = connector(App);

export { AppRedux as App };
